import {Component, Input, OnInit} from '@angular/core';
import {MeasurementData, MeasurementDataList} from "../MeasurementDataList";
import {MeasurementDescription, MeasurementDescriptionList} from "../MeasurementDescriptionList";
import {interval, Subscription} from "rxjs";
import {MeasurementSlotDetailsComponent} from "../../measurementsslots/measurementslot-details/measurement-slot-details.component";
import {MeasurementDescriptionDataservice} from "../MeasurementDescriptionDataservice";
import {MeasurementsDataService} from "../MeasurementsDataService";
import {environment} from "../../../environments/environment";
import {MeasurementItemComponent} from "../measurement-item/measurement-item.component";

@Component({
  selector: 'app-metingen-lijst',
  templateUrl: './measurement-list.component.html',
  styleUrls: ['./measurement-list.component.css']
})
export class MeasurementListComponent implements OnInit {
  @Input()
  private measurementDataList: MeasurementDataList | undefined;
  private measurementDescriptionList: MeasurementDescriptionList | undefined;
  private updateSubscription: Subscription | undefined;
  private componentList = Array<MeasurementItemComponent>();
  public loaderStatus: number = 0;



  public show = false;
  public toggleText = "Show";
  public enabled = true;
  public duration = 200;
  public type = "zoom";
  public direction = "down";



  public get animate(): any {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }

    return false;
  }

  public onToggle(): void {
    this.show = !this.show;
    this.toggleText = this.show ? "Hide" : "Show";
  }


  counter(i: number) {
    return new Array(i);
  }

  constructor(private measurementDescriptionDataservice: MeasurementDescriptionDataservice,
              private measurementsDataService: MeasurementsDataService  ){
  }

  InlayOut(): void {
    this.measurementDescriptionDataservice.GetData().subscribe(
      {
        next: measurementDescriptionList => {
          this.measurementDescriptionList = measurementDescriptionList;
          this.componentList.forEach((detail => {
            detail.UpdateDescription(this.GetDescription(detail.fullChannelNumber));
          }))
        }
      });
  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.measurementsDataService.GetData().subscribe(
      {
        next: measurementDataList => {
          this.loaderStatus = 1;
          this.measurementDataList = measurementDataList;
          this.componentList.forEach((detail => {
            detail.UpdateData(this.GetData(detail.fullChannelNumber));
          }));
          this.ReSubscribe();
        }
      });
  }


  ngOnInit(): void {
    this.InlayOut();
    this.UpdateData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  Add(metingItemComponent: MeasurementItemComponent): void {
    this.componentList.push(metingItemComponent);
  }

  GetDescription(fullChannel: number): MeasurementDescription {
    if ((this.measurementDescriptionList) && (this.measurementDescriptionList.MeasurementDescription[fullChannel]))
      return this.measurementDescriptionList.MeasurementDescription[fullChannel];
    return new MeasurementDescription();
  }


  GetData(fullChannelNumber: number): MeasurementData {
    if (this.measurementDataList) {
      for (let measurement of this.measurementDataList.MeasurementData) {
        if (measurement.channelfull == fullChannelNumber)
          return measurement;
      }
    }
    return new MeasurementData();
  }

}
